export class ProtocoloPedido{
    documentoCliente: string;
    email: string;
}
